module.exports = __webpack_public_path__ + "img/tera-diamond.d793c3dd.png";